<ngx-smart-modal focusTrap
    customClass="speakerModal"
    [backdrop]="true"
    #myModal
    identifier="myModal"
    (onAnyCloseEventFinished)="onModalClose()"
    (onOpen)="onModalOpen()"
>
    <div *ngIf="myModal.hasData()">
        <div class="c-tab__center">
            <ul class="nav nav-tabs c-tab__region" [class.c-tab__region--secondary]="secondary">
                <li class="nav-item">
                    <span
                        class="c-tab nav-link"
                        (cclClick)="getSpeakerPopUpData('speakerInfo')"
                        [class.active]="speakerInfo"
                        id="bio-label"
                        >Biography</span
                    >
                </li>
                <li class="nav-item">
                    <span title="Speaker's Sessions"
                        class="c-tab nav-link"
                        (cclClick)="getSpeakerPopUpData('speakerSessions')"
                        [class.active]="!speakerInfo"
                        id="speaker-session-label"
                        >Speaker's Sessions</span
                    >
                </li>
            </ul>
            <ng-content></ng-content>
        </div>
        <div *ngIf="speakerInfo">
            <div
                [ngClass]="{
                    'attendee-session-list-container':
                        generalSpeakerConfig.layout != 'l_banner' &&
                        sharedService.catalogLayoutConfig.listType != 'card',
                    'speaker-card--popup': sharedService.catalogLayoutConfig.listType == 'card',
                    'speaker-session-list--height': sharedService.catalogLayoutConfig.listType != 'card',
                    'general-speaker-catalog-body-region': true
                }"
                tabindex="0"
                [innerHTML]="myModal.getData().speakerInfo.speakerDetails | safeHtml"
            ></div>
            <div *ngIf="bindSpeakerBioClick"><div *ngIf="bindBioClick()"></div></div>
        </div>
        <div *ngIf="!speakerInfo">
            <div
                class="speaker-session-list--height"
                tabindex="0"
                [innerHTML]="myModal.getData().sessionList | safeHtml"
            ></div>
            <div *ngIf="bindSpeakerSessionListClick"><div *ngIf="bindClick()"></div></div>
        </div>
    </div>
</ngx-smart-modal>

<ngx-smart-modal focusTrap customClass="instanceModal" [backdrop]="true" #instanceModal identifier="instanceModal">
    <div
        style="background: #f2f2f2; overflow: hidden; padding: 10px 15px 0px 20px; border-radius: 10px;"
        *ngIf="instanceModal.hasData()"
    >
        <div [innerHTML]="instanceModal.getData().modalContent | safeHtml"></div>
    </div>
</ngx-smart-modal>
<div
    *ngIf="
        sharedService.catalogLayoutConfig.vipUnit != 'none' &&
        highlightedDataConfig.selectedList != null &&
        highlightedDataConfig.selectedList.length > 0
    "
    class="highlighted-list-section"
>
    <h4 [ngClass]="'highlighted-speaker-label-style'">
        {{ highlightedSpeakerConfig.labelConfig.label }}
        <i class="fa fa-chevron-circle-down" *ngIf="!showHighlighted" title="Show Highlighted" (cclClick)="toggleHighlighted()"></i>
        <i class="fa fa-chevron-circle-right" *ngIf="showHighlighted" title="Hide Highlighted" (cclClick)="toggleHighlighted()"></i>
    </h4>
    <div [ngClass]="showHighlighted ? 'show-highlighted-inactive' : 'show-highlighted-active'">
        <div #highlightedList>
            <div
                *ngIf="
                    !showHighlighted &&
                    showCarousel &&
                    highlightedDataConfig.displayAs === '1_carousel' &&
                    sharedService.catalogLayoutConfig.vipUnit != 'card'
                "
            >
                <ngx-slick-carousel class="carousel" #highlighted="slick-carousel" [config]="slideConfig">
                    <div ngxSlickItem *ngFor="let slide of highlightedCarousel" class="slide">
                        <div
                            [innerHTML]="slide.content | safeHtml"
                            [ngClass]="{
                                'attendee-session-list-container': highlightedSpeakerConfig.layout != 'l_banner'
                            }"
                            style="cursor: pointer;"
                            [ngStyle]="highlightedStyle"
                        ></div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</div>

<div>
    <div
        *ngIf="
            sharedService.catalogLayoutConfig.listType === 'magazine' ||
            sharedService.catalogLayoutConfig.listType === 'promoted'
        "
        class="promoted-list-section"
        [hidden]="
            promotedDataConfig.selectedList == null || promotedDataConfig.selectedList.length <= 0 || noPromotedSessions
        "
    >
        <h4
            [ngStyle]="{
                color: promotedSessionConfig.labelConfig.fontColor,
                'font-style': promotedSessionConfig.labelConfig.fontStyle,
                'text-decoration': promotedSessionConfig.labelConfig.fontStyle,
                'font-weight': promotedSessionConfig.labelConfig.fontStyle,
                'font-size': promotedSessionConfig.labelConfig.fontSize + 'px'
            }"
        >
            {{ promotedSessionConfig.labelConfig.label }}
            <i class="fa fa-chevron-circle-down" *ngIf="!showPromoted" title="Show Promoted" (cclClick)="togglePromoted()"></i>
            <i class="fa fa-chevron-circle-right" *ngIf="showPromoted" title="Hide Promoted" (cclClick)="togglePromoted()"></i>
        </h4>
        <div
            id="promotedCarouselDiv"
            [ngStyle]="
                showPromoted
                    ? { visibility: 'hidden', height: '0px', display: 'none' }
                    : { visibility: 'visible', height: 'auto', display: 'block' }
            "
        >
            <div #promotedList>
                <div *ngIf="!showPromoted && showCarousel && promotedDataConfig.displayAs === '1_carousel'">
                    <ngx-slick-carousel class="carousel" #promoted="slick-carousel" [config]="slideConfig">
                        <div ngxSlickItem *ngFor="let slide of promotedCarousel" class="slide">
                            <div
                                [innerHTML]="slide.content | safeHtml"
                                [ngClass]="{
                                    'attendee-session-list-container': promotedSessionConfig.layout != 'l_banner'
                                }"
                                style="cursor: pointer;"
                                [ngStyle]="promotedStyle"
                            ></div>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="noSpeakersInCatalog && esPage == 0 && noHighLightedSpeakers && noPromotedSessions; else showData">
    <span id="no-speaker-catalog-label"> No speakers in catalog</span>
</div>
<ng-template #showData>
    <div class="general-list-section">
        <h4 class="general-speaker-label">{{ generalSpeakerConfig.labelConfig.label }}</h4>
        <div class="attendee-session-list-text-filter">
            <div class="c-form-group">
                <div class="input-group" *ngIf="!generalSpeakerConfig.catalogConfig.hasOwnProperty('showSearchBar') || generalSpeakerConfig.catalogConfig.showSearchBar == true">
                    <input
                        aria-label="Search Speakers"
                        cclFormInput
                        id="general-list-search-label"
                        role="textbox"
                        type="text"
                        [(ngModel)]="sessionFilter.query"
                        class="c-form-group__input form-control"
                        placeholder="{{searchBarText}}"
                        (keyup.enter)="clickTextSearch()"
                    />
                    <div
                        class="input-group-append"
                        *ngIf="sessionFilter.query"
                        (cclClick)="clickRemoveFilter()"
                        title="Clear Filters"
                    >
                        <span class="c-color-picker input-group-text"><i role="presentation" class="fa fa-close"></i></span>
                    </div>

                    <div class="input-group-append" (cclClick)="clickTextSearch()" title="Search">
                        <span class="c-color-picker input-group-text"><i role="presentation" class="fa fa-search"></i></span>
                    </div>
                </div>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
            <div class="general-list-loader">
                <img alt="Loading..." *ngIf="sharedService.generalListLoading" src="assets/images/loading.gif" />
            </div>
        </div>
        <div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
            <div #generalList id="generalList"></div>
            <div class="general-list-loader">
                <img
                    alt="Loading..."
                    *ngIf="!sharedService.showLoader && loadingList"
                    src="assets/images/loading.gif"
                />
            </div>
            <div
                *ngIf="!loadingList && !noSpeakersInCatalog && nospeakersAvailable && filterResults && esPage == 0"
                id="there-were-no-speaker-found-label"
            >
                There were no speakers found
            </div>
            <div *ngIf="noSpeakersInCatalog" id="there-were-no-speaker-found-label">
                There were no speakers found
            </div>
            <div
                *ngIf="
                    !noSpeakersInCatalog &&
                    nospeakersAvailable &&
                    filterResults &&
                    esPage > 0 &&
                    sharedService.allSessionsHidden
                "
                id="no-more-records-found-label"
            >
                No More Records Found
            </div>
        </div>
    </div>
</ng-template>
